import Form from './components/Form'
// import Validator from 'bootstrap-validator'

const settings = {
  lang: ['fr'], // TODO: add here your languages
  userLang: navigator.language || navigator.userLanguage,
  cdnUrl: 'https://res.cloudinary.com/dqfh7voko/raw/upload/',
  wsUrl: 'https://www.quotatis.fr/ecf.php',
  selector: 'qcf'
}

// Check if the parent page has already loaded jQuery
if (!window.jQuery) {
  const jq = document.createElement('script')
  jq.type = 'text/javascript'
  jq.src = '//ajax.googleapis.com/ajax/libs/jquery/1.12.0/jquery.min.js'
  document.getElementsByTagName('head')[0].appendChild(jq)
}

const qcf = new Form(settings)
qcf.init()

// const vldtor = new Validator()



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/